import { render } from "./list.vue?vue&type=template&id=116d6d4e"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import exportComponent from "/home/eymekkjd/infos-projet.app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__